const observedPreviews = new WeakSet();

const updateScale = preview => {
    const width = preview.clientWidth;

    if (width === 0) {
        return;
    }

    const scale = Math.min(1, width / Number(preview.dataset.previewMinWidth));

    preview.style.setProperty('--preview-scale', String(scale));
};

const resizeObserver = new ResizeObserver(entries => {
    entries.forEach(entry => updateScale(entry.target));
});

export const initializeTemplatePreviewScale = root => {
    const selector = '[data-preview-min-width]';
    const previews = root.matches?.(selector) ? [root] : root.querySelectorAll(selector);

    previews.forEach(preview => {
        if (!observedPreviews.has(preview)) {
            observedPreviews.add(preview);
            resizeObserver.observe(preview);
        }

        updateScale(preview);
    });
};
